import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import styled from 'styled-components';
import { MdGroups, MdWrongLocation, MdTrendingDown, MdTune, MdInfoOutline, MdNightsStay } from 'react-icons/md';

export type ModeloRisco = 'sublocacao' | 'fuga' | 'poucoUso' | 'pernoite' | 'personalizado';

interface CardModelo {
  chave: ModeloRisco;
  titulo: string;
  descricao: string;
  icone: React.ReactNode;
  aviso?: string;
}

const MODELOS: CardModelo[] = [
  {
    chave: 'sublocacao',
    titulo: 'Sublocação',
    descricao: 'Quando o seu locatário aluga o veículo para outra pessoa.',
    icone: <MdGroups size={30} />,
    aviso:
      'Com base em nossa experiência, um veículo que roda mais do que 2.240 km em 7 dias (média de 320 km por dia) pode estar passando por sublocação. Lembrando que é 100% editável, o que selecionamos abaixo é apenas uma sugestão.',
  },
  {
    chave: 'fuga',
    titulo: 'Fuga da Região',
    descricao: 'Alerta e bloqueia quando o veículo se afasta da cidade da sua empresa.',
    icone: <MdWrongLocation size={30} />,
  },
  {
    chave: 'poucoUso',
    titulo: 'Pouco Uso',
    descricao: 'Avisa quando o veículo roda muito pouco no período.',
    icone: <MdTrendingDown size={30} />,
  },
  {
    chave: 'pernoite',
    titulo: 'Pernoite fora do endereço',
    descricao: 'Avisa quando o veículo passa a madrugada longe do endereço do locatário com frequência.',
    icone: <MdNightsStay size={30} />,
    aviso:
      'Vou olhar onde o veículo de cada locação dorme, entre 0h e 5h no horário do endereço do locatário. Se em 3 das últimas 7 noites ele dormir a mais de 300 m do endereço, você é avisado. Tudo é editável na próxima tela, e locatários sem o endereço no mapa podem ser localizados lá mesmo.',
  },
  {
    chave: 'personalizado',
    titulo: 'Personalizado',
    descricao: 'Monte um evento do zero com as opções que quiser.',
    icone: <MdTune size={30} />,
  },
];

const Grade = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 14px;
`;

const CardBotao = styled.button`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-align: left;
  background: #fff;
  border: 1px solid #e0e5ee;
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #1f467e;
    background: #f5f8fd;
    box-shadow: 0 2px 10px rgba(31, 70, 126, 0.1);
  }
`;

const IconeCard = styled.div`
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #eef2f8;
  color: #1f467e;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  show: boolean;
  onClose: () => void;
  onEscolher: (modelo: ModeloRisco) => void;
}

export default function ModalModelosRisco({ show, onClose, onEscolher }: Props) {
  const [aviso, setAviso] = useState<CardModelo | null>(null);

  useEffect(() => {
    if (show) setAviso(null);
  }, [show]);

  const escolher = (modelo: CardModelo) => {
    if (modelo.aviso) {
      setAviso(modelo);
      return;
    }
    onEscolher(modelo.chave);
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header style={{ backgroundColor: '#1f467e' }} className="text-white border-0">
        <Modal.Title style={{ fontSize: 16, fontWeight: 600 }}>
          {aviso ? aviso.titulo : 'Escolha um modelo de gestão de risco'}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 20 }}>
        {aviso ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 14, padding: '8px 8px 4px' }}>
            <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#eef2f8', color: '#1f467e', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MdInfoOutline size={34} />
            </div>
            <p style={{ margin: 0, color: '#374151', fontSize: 14.5, lineHeight: 1.65, maxWidth: 460 }}>
              {aviso.aviso}
            </p>
          </div>
        ) : (
          <Grade>
            {MODELOS.map((m) => (
              <CardBotao key={m.chave} type="button" onClick={() => escolher(m)}>
                <IconeCard>{m.icone}</IconeCard>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 600, color: '#1f467e', marginBottom: 4 }}>{m.titulo}</div>
                  <div style={{ fontSize: 13, color: '#5a6b7d', lineHeight: 1.5 }}>{m.descricao}</div>
                </div>
              </CardBotao>
            ))}
          </Grade>
        )}
      </Modal.Body>

      <Modal.Footer>
        {aviso ? (
          <>
            <Button variant="outline-secondary" onClick={() => setAviso(null)}>
              Voltar
            </Button>
            <Button
              style={{ backgroundColor: '#1f467e', borderColor: '#1f467e', fontWeight: 600 }}
              onClick={() => onEscolher(aviso.chave)}
            >
              Entendido
            </Button>
          </>
        ) : (
          <Button variant="outline-secondary" onClick={onClose}>
            Cancelar
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
